import React from "react";
import "./QualityPolicy.css";

const QualityPolicy = () => {
  return (
    <div className="quality-container">
      <div className="quality-content">
        <h1>Our Quality Policy</h1>
        <p>
          <strong>Surya Enterprises</strong> is committed to providing quality cleaning services. 
          All the staff are responsible for compliance with the Quality Management System and for 
          ensuring that all procedures and work instructions are properly executed, meeting the 
          highest standards. 
        </p>
        <p>
          All affected staff shall be trained in the processes they are required to perform. The 
          adoption of the Quality Management System is essential to the continued growth and success 
          of the business.
        </p>
      </div>
    </div>
  );
};

export default QualityPolicy;
